// eslint-disable-next-line import/no-extraneous-dependencies
import { DateTime } from 'luxon';

let timeZone = 'UTC+00:00';
export default {
  install(Vue) {
    Vue.setZone = function (zone) {
      timeZone = zone;
    };
    Vue.parseDateTimeFromISO = function (isoTime, format) {
      format = format != null ? format : 'yyyy-MM-dd HH:mm:ss';
      return isoTime
        ? DateTime.fromISO(isoTime)
          .setZone(timeZone)
          .toFormat(format)
        : isoTime;
    };
    Vue.parseDateTime = function (ts, format) {
      ts *= 1;
      format = format != null ? format : 'yyyy-MM-dd HH:mm:ss';
      return ts
        ? DateTime.fromMillis(ts)
          .setZone(`UTC${localStorage.getItem('countryOffset')}`)
          .toFormat(format)
        : ts;
    };
    Vue.parseDateTimeFromMs = function (ts, format) {
      ts *= 1;
      format = format != null ? format : 'yyyy-MM-dd HH:mm:ss';
      const time = localStorage.getItem('countryOffset').split(':');

      if (time.length > 1) {
        return ts
          ? DateTime.fromMillis(ts)
            .setZone('local')
            .plus({ hours: time[0], minute: time[0].charAt(0) + (time[1] * 1) })
            .toFormat(format)
          : ts;
      }
      return 'No OffSet Value';
    };
    Vue.parseDateTimeOrgin = function (ts, format) {
      ts *= 1;
      format = format != null ? format : 'yyyy-MM-dd HH:mm:ss';
      const time = localStorage.getItem('countryOffset').split(':');
      if (time.length > 1) {
        return ts
          ? DateTime.fromMillis(ts)
            .setZone('UTC')
            .plus({ hours: -1 * time[0], minute: -1 * (time[0].charAt(0) + (time[1] * 1)) })
            .toFormat(format)
          : ts;
      }
      return 'No OffSet Value';
    };
    Vue.parseMilliSecOrgin = function (ts) {
      let utcStr = localStorage.getItem('countryOffset');
      if (utcStr.indexOf('-') > -1) {
        utcStr = utcStr.replace('-', '+');
      } else {
        utcStr = utcStr.replace('+', '-');
      }
      ts *= 1;
      const time = utcStr.split(':');
      if (time.length > 1) {
        return ts + time[0] * 60 * 60 * 1000 + time[1] * 60 * 1000;
      }
      return 'No OffSet Value';
    };
    Vue.parseUTCDateTime = function (ts, format) {
      format = format != null ? format : 'yyyy-MM-dd HH:mm:ss';
      return ts
        ? DateTime.fromMillis(ts)
          .setZone('UTC')
          .toFormat(format)
        : ts;
    };
    Vue.parseISO = function (ts) {
      return ts
        ? DateTime.fromMillis(ts)
          .setZone(timeZone)
          .toISO()
        : ts;
    };
    Vue.getTimestamp = function (isoTime, option) {
      let tsObject = DateTime.fromISO(isoTime)
        .setZone(timeZone);
      if (option != null) {
        tsObject = tsObject.set(option);
      }
      return tsObject.toMillis();
    };
    Vue.fromISO = function (datetime) {
      return DateTime.fromISO(
        datetime,
        { zone: timeZone },
      );
    };
    Vue.fromMillis = function (ts) {
      return DateTime.fromMillis(
        ts,
        { zone: timeZone },
      );
    };
    Vue.getCurrent = function () {
      return DateTime.local()
        .setZone(timeZone);
    };
    Vue.firstDayOfWeek = function (datetime) {
      if (datetime.weekday > 1) {
        return datetime.minus({ days: datetime.weekday - 1 });
      }
      return datetime;
    };
    Vue.lastDayOfWeek = function (datetime) {
      if (datetime.weekday < 7) {
        return datetime.plus({ days: 7 - datetime.weekday });
      }
      return datetime;
    };
    Vue.fromFormat = function (datetime, format, offset) {
      let zone = timeZone;
      if (offset) {
        zone = offset;
      }
      return DateTime.fromFormat(
        datetime,
        format,
        { zone },
      );
    };
    Vue.getCurrent = function (zone) {
      return DateTime.local()
        .setZone(zone);
    };
    Vue.getMinusDate = function (date, type, format, value) {
      switch (type) {
        case 'd':
          return DateTime.fromFormat(date, format).minus({ days: value });
        case 'w':
          return DateTime.fromFormat(date, format).minus({ weeks: value });
        case 'm':
          return DateTime.fromFormat(date, format).minus({ month: value });
        default:
          alert('invalid type');
      }
    };
    Vue.getPlusDate = function (date, type, format, value) {
      switch (type) {
        case 'd':
          return DateTime.fromFormat(date, format).plus({ days: value });
        case 'w':
          return DateTime.fromFormat(date, format).plus({ weeks: value });
        case 'm':
          return DateTime.fromFormat(date, format).plus({ month: value });
        default:
          alert('invalid type');
      }
    };
    Vue.diff = function (start, end, type) {
      switch (type) {
        case 'd':
          return Math.floor((new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24));
        case 'w':
          return Math.floor((new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24 * 7));
        case 'm':
          // eslint-disable-next-line no-case-declarations
          start = start.substr(0, 7);
          end = end.substr(0, 7);
          // eslint-disable-next-line no-case-declarations
          const startMonth = new Date(`${start}-01`);
          // eslint-disable-next-line no-case-declarations
          const endMonth = new Date(`${end}-01`);
          return (12 * (endMonth.getFullYear() - startMonth.getFullYear())) + (endMonth.getMonth() - startMonth.getMonth());
        default:
          // eslint-disable-next-line no-alert
          alert('invalid type');
      }
    };
    Vue.getLastDayOfMonth = function (year, month) {
      const { daysInMonth } = DateTime.local(year, month);
      if (month < 10) {
        month = `0${month}`;
      }
      return `${year}-${month}-${daysInMonth}`;
    };
  },
};



// WEBPACK FOOTER //
// ./src/utils/CustomDateTime.js